import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import React from 'react'
import tw from 'twin.macro'
import { OpportunityActionButton } from 'src/components/opportunities/OpportunityActionButton'
import { Chip } from 'src/components/shared/Chip'
import { TableLabels } from 'src/components/shared/label/TableLabels'
import { Opportunity } from 'src/interfaces/opportunity'
import { colors } from 'src/theme'
import { OpportunityStatus } from './enums'

export const opportunityColumns: GridColDef<Opportunity>[] = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1.6,
    minWidth: 200,
    sortable: false,
  },
  {
    field: 'markets',
    headerName: 'Market',
    flex: 1.4,
    minWidth: 200,
    sortable: false,
    renderCell: (params: GridRenderCellParams<Opportunity>) => (
      <TableLabels
        labels={params.row.markets.map((market) => {
          return market.title
        })}
        moreLabel="market"
      />
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    sortable: false,
    renderCell: (params: GridRenderCellParams<Opportunity>) =>
      params.row.status === OpportunityStatus.Open ? (
        <Chip className={tw`bg-[#E6F9E9]`} textColor={colors.COLORS_GREEN_500} text="Open" />
      ) : (
        <Chip className={tw`bg-[#EDEDED]`} textColor={colors.SHADES_GREY_600} text="Closed" />
      ),
  },
  {
    field: 'candidateCount',
    headerName: 'Applications',
    width: 120,
    sortable: false,
  },
  {
    field: 'actions',
    headerName: '',
    width: 68,
    sortable: false,
    align: 'right',
    renderCell: (params: GridRenderCellParams<Opportunity>) => (
      <OpportunityActionButton opportunity={params.row} />
    ),
  },
]
